<template>
  <router-view></router-view>
  <audio class="audio"
         src="mp3/success.mp3"
         controls
         id="successAudio"
         hidden="true">
  </audio>
</template>


<style>

html,
body,
#app {
  width: 100%;
  height: 100%;
}

/*修复input选中没有蓝色的bug*/
.el-input__inner::selection {
  background-color: #2563eb !important;
  color: #fff !important;
}

</style>
<script setup lang="ts">
</script>
